//#region Imports
import React from "react";
import { AppBar, Toolbar } from "@mui/material";

// Components
import ControlButtons from "./Control Buttons";
import { BurgerMenu } from "./Navigation";
//#endregion

/**
 * Creates tabletop/mobile header element
 * @param {Object} props Props of the element
 * @param {Number} props.xPaddings Paddings on the X axis
 * @returns {JSX.Element} An element of the tabletop/mobile header
 */
const MobileHeader = ({ xPaddings }) => {
  return (
    <AppBar
      component="header"
      position="static"
      sx={{ py: 1.5, px: xPaddings }}
      elevation={0}>
      <Toolbar
        variant="dense"
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
        }}>
        <BurgerMenu />
        <ControlButtons isMobile={true} />
      </Toolbar>
    </AppBar>
  );
};

export default MobileHeader;
